import { render } from "./Downlink1.vue?vue&type=template&id=bd2c07d0"
import script from "./Downlink1.vue?vue&type=script&lang=js"
export * from "./Downlink1.vue?vue&type=script&lang=js"

import "./Downlink1.vue?vue&type=style&index=0&id=bd2c07d0&lang=css"

import exportComponent from "E:\\trackzone\\Admin_panel\\admin panel\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__